import { render } from "./content-information.vue?vue&type=template&id=fca5b154&scoped=true"
import script from "./content-information.vue?vue&type=script&lang=js"
export * from "./content-information.vue?vue&type=script&lang=js"

import "./content-information.vue?vue&type=style&index=0&id=fca5b154&scoped=true&lang=scss"

import exportComponent from "/opt/TeamCity/buildAgent/work/f19c936fb20a8ac2/vue-embed/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fca5b154"]])

export default __exports__